import React from "react";

const Layout = ({ children, title }) => {
  return (
    <>
        <title>{title || "ODIR - Cloud Management Platform"}</title>
        <meta name="description" content="ODIR - Your intelligent cloud management platform" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <main style={{ position: "relative", minHeight: "100vh" }}>{children}</main>
    </>
  );
};

export default Layout;
